export default __webpack_public_path__ + "static/media/videos-placeholder.d703d1a1.png";